export default "__VITE_ASSET__DwGM13jI__"